import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface IOfficerRequestProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    applicantName: IPropertyInfoMetadata;
    applicantEmailAddress: IPropertyInfoMetadata;
    applicantContactNumber: IPropertyInfoMetadata;
    unitTypeLookupItemId: IPropertyInfoMetadata;
    unitName: IPropertyInfoMetadata;
    unitNumber: IPropertyInfoMetadata;
    unitContactName: IPropertyInfoMetadata;
    unitContactOffice: IPropertyInfoMetadata;
    unitContactEmailAddress: IPropertyInfoMetadata;
    unitContactNumber: IPropertyInfoMetadata;
    meetingDate: IPropertyInfoMetadata;
    meetingDay: IPropertyInfoMetadata;
    meetingTime: IPropertyInfoMetadata;
    meetingVenue: IPropertyInfoMetadata;
    meetingPurposeOfVipAttendance: IPropertyInfoMetadata;
    meetingOtherRelevantDetails: IPropertyInfoMetadata;
    meetingNameOrRankOfAnyOtherSeniorGuests: IPropertyInfoMetadata;
    diningVenue: IPropertyInfoMetadata;
    diningTime: IPropertyInfoMetadata;
    diningCost: IPropertyInfoMetadata;
    supportTypeLookupItemId: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Properties

    supportTypeLookupItem: IPropertyInfoMetadata;
    unitTypeLookupItem: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Collection Properties

    officerRequestInvitations: IPropertyInfoMetadata;

    // #endregion

}

export const OfficerRequest: ITypeInfoMetadata<IOfficerRequestProperties> = {
    attributes: [
        {
            id: "{25DB98C9-F872-41F9-8A3B-5BD04CDF9535}",
            $type: "SeriouslyRAD.Framework.Data.ClientAwareIdAttribute, SeriouslyRAD.Framework.Data.Entities"
        },
        {
            name: "OfficerRequest",
            nameFriendly: "Request",
            namePlural: "OfficerRequests",
            namePluralFriendly: "Requests",
            $type: "SeriouslyRAD.Framework.Data.ClientAwareNameAttribute, SeriouslyRAD.Framework.Data.Entities"
        }
    ],
    name: "OfficerRequest",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        applicantName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Name"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+ApplicantNameMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 0
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "ApplicantName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        applicantEmailAddress: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Email Address"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+ApplicantEmailAddressMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 1
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "ApplicantEmailAddress",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        applicantContactNumber: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Contact No."
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+ApplicantContactNumberMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 2
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "ApplicantContactNumber",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitTypeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Type"
                },
                {
                    foreignEntityAlias: "OfficerRequestsByUnitType",
                    typeDescription: "Officer Request Unit Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+UnitTypeLookupItemIdMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 3
                }
            ],
            name: "UnitTypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Name"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+UnitNameMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 4
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "UnitName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitNumber: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Number"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+UnitNumberMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 5
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "UnitNumber",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitContactName: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Contact Name"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+UnitContactNameMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 6
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "UnitContactName",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitContactOffice: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Contact Office (eg DC)"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+UnitContactOfficeMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 7
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "UnitContactOffice",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitContactEmailAddress: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Contact Email Address"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 8
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "UnitContactEmailAddress",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitContactNumber: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Contact Number"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 9
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "UnitContactNumber",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingDate: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Date"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+MeetingDateMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 10
                }
            ],
            name: "MeetingDate",
            propertyTypeId: "System.Nullable`1[[System.DateOnly, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingDay: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Day"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+MeetingDayMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 11
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "MeetingDay",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingTime: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Time"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+MeetingTimeMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 12
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "MeetingTime",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingVenue: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Venue"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+MeetingVenueMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 13
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "MeetingVenue",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingPurposeOfVipAttendance: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Purpose of VIP attendance"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+MeetingPurposeOfVipAttendanceMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 14
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "MeetingPurposeOfVipAttendance",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingOtherRelevantDetails: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Other relevant details - ie White Table Event, Dress Regalia etc"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 15
                }
            ],
            name: "MeetingOtherRelevantDetails",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        meetingNameOrRankOfAnyOtherSeniorGuests: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Name/Rank of any other senior guest(s)"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 16
                }
            ],
            name: "MeetingNameOrRankOfAnyOtherSeniorGuests",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        diningVenue: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Venue"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 17
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "DiningVenue",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        diningTime: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Time"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 18
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "DiningTime",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        diningCost: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Cost"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 19
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework.Data.Entities",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                }
            ],
            name: "DiningCost",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        supportTypeLookupItemId: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework.Data.Entities",
                    displayName: "Support Type"
                },
                {
                    foreignEntityAlias: "OfficerRequestsBySupportType",
                    typeDescription: "Officer Request Support Types",
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareLookupItemAttribute, SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareMandatoryEvaluatorAttribute`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequest+SupportTypeLookupItemIdMandatoryEvaluatorAttributeType, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
                },
                {
                    $type: "SeriouslyRAD.Framework.Data.ClientAwareOrderAttribute, SeriouslyRAD.Framework.Data.Entities",
                    order: 20
                }
            ],
            name: "SupportTypeLookupItemId",
            propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        supportTypeLookupItem: {
            name: "SupportTypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        unitTypeLookupItem: {
            name: "UnitTypeLookupItem",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.LookupItem, SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        officerRequestInvitations: {
            name: "OfficerRequestInvitations",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[EscortingOfficerCoordinator.Data.Entities.OfficerRequestInvitation, EscortingOfficerCoordinator.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "EscortingOfficerCoordinator.Data.Entities.OfficerRequest, EscortingOfficerCoordinator.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

